import React, {HTMLAttributes}   from 'react';
import clsx from 'clsx';

import { Slot, type AsChildProps } from '@/stories/atoms/Slot/Slot';
import styles from './grid.module.css';

export type GridProps = AsChildProps<
  {
    /** Size is the number of grid col (to used in a Grid component */
    nbCols?: number,
    nbRows?: number,
    nbColsS?: number,
    columns?: string,
    scrollable?: boolean,
    gap?: 'xs' | 's' | 'l' | 'xl',
    className?: string
  },
  HTMLAttributes<HTMLDivElement>
>

export const Grid = ({
  asChild,
  nbCols,
  nbRows,
  nbColsS,
  scrollable,
  columns,
  gap,
  className,
  children,
  ...props
}: GridProps)=> {
  const Component = asChild ? Slot : "div";

  return (
    <Component
      className={clsx(styles.grid, scrollable && styles.scrollable, className)} 
      {...(nbCols || nbColsS || columns || gap || nbRows ? {
        style: {
          ...(nbCols ? {'--grid-nb-cols': nbCols} : {}),
          ...(nbRows ? {'--grid-nb-rows': nbRows} : {}),
          ...(nbColsS ? {'--grid-nb-cols-s': nbColsS} : {}),
          ...(columns ? {'--template-columns': columns} : {}),
          ...(gap ? {'--gap': `var(--spacing-${gap})`} : {})
        } as React.CSSProperties
      } : {})}
      {...props}>
      {children}
    </Component>
  )
};

